import { NavLink } from 'react-router-dom'
import OpenNewTab from '../hooks/OpenNewTab'

 const Icon = (props) => {
    const {openInNewTab} = OpenNewTab();
  return (
    <>
      <NavLink className="social-item" to="" onClick={(e) => openInNewTab(props.link)} ><i>{props.icon}</i></NavLink>
    </>
  )
}
export default Icon